import React, { useState, useEffect } from "react";
import "./Home.css"; // تأكد من وجود التنسيقات الخاصة

function About({ isEnglish, theme }) {
  const [currentImage, setCurrentImage] = useState(0);
  const images = [
    "customures/1.jpeg",
    "customures/2.jpeg",
    "customures/3.jpeg",
    "customures/4.jpeg",
    "customures/5.jpeg",
    "customures/6.jpeg",
    "customures/7.jpeg",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className={`about-page ${theme}`} style={{ height:"79vh", display: "flex", flexDirection: "column", gap: "50px" }}>
      {/* Section 1: About Content and Card */}
      <section style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", padding: "30px" }}>
        <div style={{ flex: 1, minWidth: "300px" }}>
          <h1 className={`MainHeading ${theme}`}>{isEnglish ? "About DIGISMA" : "عن ديجسما"}</h1>
          <p>
            {isEnglish
              ? "We are a creative team dedicated to helping "
              : "نحن فريق إبداعي مكرس لمساعدة "}
            <br />
            {isEnglish
              ? "businesses and individuals bring their visions to life."
              : "الشركات والأفراد على تحويل رؤاهم إلى واقع."}
          </p>
          <p>
            {isEnglish
              ? "With years of experience in design and development,"
              : "بفضل سنوات من الخبرة في التصميم والتطوير،"}
            <br />
            {isEnglish
              ? "we've helped clients across various industries"
              : "ساعدنا عملاء في مختلف الصناعات على"}
            <br />
            {isEnglish
              ? "create meaningful connections with their audience through"
              : "بناء روابط فعالة مع جمهورهم من خلال"}
            <br />
            {isEnglish
              ? "thoughtful design and strategic execution."
              : "التصميم المدروس والتنفيذ الاستراتيجي."}
          </p>
          <p>
            {isEnglish
              ? "Our philosophy is simple: Relax, leave it to us! We handle the complex details so you can focus on what matters most to you."
              : "فلسفتنا بسيطة: استرخي، واترك الأمر لنا! نحن نتولى التفاصيل المعقدة حتى تتمكن من التركيز على ما يهمك أكثر."}
          </p>
        </div>
        <img src="./MainLogo.jpeg" alt="" style={{width: "200px", borderRadius:"50%"}}></img>
      </section>

      {/* Section 2: Our Values */}

      {/* Section 3: Our Team */}
    </div>
  );
}

export default About;
